query groupsCube($scenarioId: ID!, $filter: PaginationInput!, $originId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    groups(filter: $filter) {
      items {
        id
        code
        label
        name
        capacity
        clientCode
        visibleForEnrollment
        isActive
        labels {
          id
          name
        }
        term {
          id
          code
        }
        course {
          code
          name
          curriculum {
            id
            name
            program {
              id
              code
              campus {
                id
                code
                name
                __typename
              }
            }
          }
        }
        links {
          id
          vacancies
          code
          bundle {
            id
            code
            label
            name
            capacity
          }
        }
        enrollmentStats {
          id
          enrollmentsCount
          waitingListsCount
        }
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
        __typename
      }
      __typename
    }
  }
}
